import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export const BottomCtaBlock = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-primary/10 via-background to-secondary/10"></div>
      
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          {t('landing.bottomCta.title')}
        </h2>
        <p className="text-lg text-muted-foreground mb-2">
          {t('landing.bottomCta.subtitle')}
        </p>
        <p className="text-sm text-muted-foreground mb-8">
          {t('landing.bottomCta.footer')}
        </p>
        <Button size="lg" onClick={() => navigate('/auth')} className="text-lg px-8 py-6">
          {t('landing.bottomCta.button')}
        </Button>
      </div>
    </section>
  );
};
